// extracted by mini-css-extract-plugin
export var text = "styles-module--text--0EVNI";
export var btn = "styles-module--btn--Dj1aJ";
export var icon = "styles-module--icon--4ooL2";
export var logbook1 = "styles-module--logbook1--11-6O";
export var logbook2 = "styles-module--logbook2--081GX";